import type { RootState } from '@generalTypes/rootStateTypes';
import { selectValidationInfoForNodeAside } from '@newStore/validation/validationSelectors';
import type { EditComponentProperty } from '@nodeTypeConfig/configTypes';
import type React from 'react';
import { useSelector } from 'react-redux';
import './AsideValidation.scss';

export type AsideValidationProps = {
  property: EditComponentProperty | undefined;
  component: string;
};

const AsideValidation: React.FC<AsideValidationProps> = ({ property, component }) => {
  const errors = useSelector((state: RootState) =>
    selectValidationInfoForNodeAside(state, component, property),
  );

  if (!errors.validationErrors.length) {
    return null;
  }

  return (
    <div className="aside-validation">
      {/* // below is copied from ValidationErrors.tsx */}
      {errors.validationErrors.map((error) => (
        <div key={error.code} className={`error-message type-${error.type.toLowerCase()}`}>
          <div className="error-message-content">
            <span dangerouslySetInnerHTML={{ __html: error.message }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AsideValidation;
